import type { ThemeState } from '@atlaskit/tokens/theme-config';

import { getDefaultTheme } from './defaultTheme.ts';

export const buildThemeFromState = (themeState: Partial<ThemeState>): Partial<ThemeState> => {
	return {
		...getDefaultTheme(),
		...themeState,
		typography: 'typography',
	};
};
